module.exports = __webpack_public_path__ + "img/bg_pay_stay.f48e4796.png";